import { useTranslate } from '../../../context/languageContext';
import { useTheme } from '../../../context/themeContext';
import { R } from '../../../R';
import { useCookiesManagerStyles } from '../useCookiesManagerStyles';

interface CookiesManagerContentProps {
  setOpened: (opened: boolean) => void;
  onAccept: () => void;
  onDecline: () => void;
}

export default function CookiesManagerContent(props: CookiesManagerContentProps) {
  const theme = useTheme();
  const t = useTranslate();
  const Close = R.drawables.general.Ic_close;
  
  // hook personalizado para obtener los estilos
  const styles = useCookiesManagerStyles();

  const handleAccept = () => {
    props.onAccept();
    props.setOpened(false);
  };

  const handleDecline = () => {
    props.onDecline();
    props.setOpened(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <p style={styles.headerText}>{t('cookies_title')}</p>
        {/* <Close
          onClick={() => {
            // Si el usuario cierra el modal, se presupone que acepta las cookies
            props.onAccept();
            props.setOpened(false);
          }}
          fill={theme.colors.white}
          style={styles.close}
        /> */}
      </div>
      <div style={styles.body}>
        <div style={styles.content}>
          <div style={styles.text}>
            <p style={styles.paragraph}>
              {t('cookies_consent_text')}
            </p>
          </div>
          <div style={styles.buttons}>
            <button
              style={styles.declineButton}
              onClick={handleDecline}
            >
              {t('cookies_decline')}
            </button>
            <button
              style={styles.acceptButton}
              onClick={handleAccept}
            >
              {t('cookies_accept')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
